import { Link } from 'react-router-dom';
import logo from '../assets/eat_logo.png';

const QUICK_LINKS = [
  { label: 'Home', to: '/' },
  { label: 'About E.A.T.', to: '/about' },
  { label: 'Services', to: '/services' },
  { label: 'Portfolio', to: '/portfolio' },
  { label: 'CampusToCorp Program', to: '/program' },
  { label: 'E.A.T. IdeaToImpact', to: '/ideatoimpact' },
  { label: 'Project Assistance', to: '/project-assistance' },
  { label: 'Careers', to: '/careers' },
  { label: 'FAQ', to: '/faq' },
  { label: 'Contact', to: '/contact' },
  { label: 'Enroll Now', to: '/register' },
];

export default function Footer() {
  return (
    <footer style={{ background: '#1A1A2E', padding: '60px 0 24px' }}>
      <div className="container">
        {/* Grid */}
        <div
          style={{
            display: 'grid',
            gridTemplateColumns: '1.6fr 1fr 1fr 1.2fr',
            gap: 40,
            marginBottom: 48,
          }}
          className="footer-grid"
        >
          {/* Brand */}
          <div>
            <Link to="/" style={{ display: 'inline-block', marginBottom: 14 }}>
              <img src={logo} alt="E.A.T." style={{ height: 32, width: 'auto' }} />
            </Link>
            <p
              style={{
                fontSize: 13,
                color: 'rgba(255,255,255,0.52)',
                lineHeight: 1.75,
                maxWidth: 280,
              }}
            >
              Bridging the campus-to-corporate gap through real-world internship experience,
              industry mentorship, and structured career readiness.
            </p>
            <div
              style={{
                marginTop: 20,
                padding: '12px 16px',
                background: 'rgba(0,174,239,0.08)',
                borderRadius: 10,
                border: '1px solid rgba(0,174,239,0.15)',
              }}
            >
              <p
                style={{
                  fontSize: 12,
                  color: 'rgba(255,255,255,0.4)',
                  fontWeight: 600,
                  letterSpacing: '1.5px',
                  textTransform: 'uppercase',
                  marginBottom: 4,
                }}
              >
                Flagship Program
              </p>
              <p
                style={{
                  fontSize: 14,
                  color: '#00AEEF',
                  fontFamily: "'Montserrat', sans-serif",
                  fontWeight: 700,
                }}
              >
                CampusToCorp
              </p>
              <p style={{ fontSize: 11, color: 'rgba(255,255,255,0.45)', marginTop: 2 }}>
                Internship & Corporate Readiness
              </p>
            </div>
          </div>

          {/* Quick Links */}
          <div>
            <h5
              style={{
                fontFamily: "'Montserrat', sans-serif",
                fontSize: 11,
                fontWeight: 700,
                color: 'rgba(255,255,255,0.38)',
                letterSpacing: '2px',
                textTransform: 'uppercase',
                marginBottom: 18,
              }}
            >
              Quick Links
            </h5>
            <ul style={{ listStyle: 'none', display: 'flex', flexDirection: 'column', gap: 9 }}>
              {QUICK_LINKS.map(({ label, to }) => (
                <li key={to}>
                  <Link
                    to={to}
                    style={{
                      color: 'rgba(255,255,255,0.60)',
                      fontSize: 13,
                      textDecoration: 'none',
                      transition: 'color 0.2s',
                    }}
                    onMouseEnter={(e) => (e.currentTarget.style.color = '#00AEEF')}
                    onMouseLeave={(e) => (e.currentTarget.style.color = 'rgba(255,255,255,0.60)')}
                  >
                    {label}
                  </Link>
                </li>
              ))}
            </ul>
          </div>

          {/* Program */}
          <div>
            <h5
              style={{
                fontFamily: "'Montserrat', sans-serif",
                fontSize: 11,
                fontWeight: 700,
                color: 'rgba(255,255,255,0.38)',
                letterSpacing: '2px',
                textTransform: 'uppercase',
                marginBottom: 18,
              }}
            >
              Internship Program
            </h5>
            {[
              ['Duration', '6 Months / Cycle'],
              ['Mode', 'Hybrid (Online + Offline)'],
              ['Locations', 'Belgaum & Bangalore'],
              ['Seats', '100 per Cycle'],
              ['Eligibility', 'BE/BTech, BCA, MCA, BSc IT'],
            ].map(([k, v]) => (
              <div key={k} style={{ marginBottom: 10 }}>
                <span
                  style={{
                    fontSize: 10,
                    color: 'rgba(255,255,255,0.35)',
                    fontWeight: 600,
                    letterSpacing: '1px',
                    textTransform: 'uppercase',
                    display: 'block',
                    marginBottom: 1,
                  }}
                >
                  {k}
                </span>
                <span style={{ fontSize: 12, color: 'rgba(255,255,255,0.68)' }}>{v}</span>
              </div>
            ))}
          </div>

          {/* Contact */}
          <div>
            <h5
              style={{
                fontFamily: "'Montserrat', sans-serif",
                fontSize: 11,
                fontWeight: 700,
                color: 'rgba(255,255,255,0.38)',
                letterSpacing: '2px',
                textTransform: 'uppercase',
                marginBottom: 18,
              }}
            >
              Contact
            </h5>
            <div style={{ display: 'flex', flexDirection: 'column', gap: 12 }}>
              <a
                href="mailto:furqan.mestri@eattechpl.com"
                style={{
                  display: 'flex',
                  alignItems: 'flex-start',
                  gap: 8,
                  color: 'rgba(255,255,255,0.65)',
                  fontSize: 13,
                  textDecoration: 'none',
                }}
              >
                <span style={{ marginTop: 1 }}>📧</span>
                <span>furqan.mestri@eattechpl.com</span>
              </a>
              <a
                href="tel:+918867799701"
                style={{
                  display: 'flex',
                  alignItems: 'center',
                  gap: 8,
                  color: 'rgba(255,255,255,0.65)',
                  fontSize: 13,
                  textDecoration: 'none',
                }}
              >
                <span>📞</span>
                <span>+91 88677 99701</span>
              </a>

              <div style={{ display: 'flex', gap: 10, marginTop: 4 }}>
                <a
                  href="https://www.instagram.com/eat_technologies_pl/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 6,
                    background: 'rgba(255,255,255,0.06)',
                    border: '1px solid rgba(255,255,255,0.10)',
                    borderRadius: 8,
                    padding: '7px 12px',
                    fontSize: 12,
                    color: 'rgba(255,255,255,0.65)',
                    textDecoration: 'none',
                    transition: 'all 0.2s',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.borderColor = '#00AEEF';
                    e.currentTarget.style.color = '#00AEEF';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.borderColor = 'rgba(255,255,255,0.10)';
                    e.currentTarget.style.color = 'rgba(255,255,255,0.65)';
                  }}
                >
                  <span>📸</span> Instagram
                </a>
                <a
                  href="https://www.linkedin.com/company/eat-technologies-pvt-ltd/"
                  target="_blank"
                  rel="noopener noreferrer"
                  style={{
                    display: 'flex',
                    alignItems: 'center',
                    gap: 6,
                    background: 'rgba(255,255,255,0.06)',
                    border: '1px solid rgba(255,255,255,0.10)',
                    borderRadius: 8,
                    padding: '7px 12px',
                    fontSize: 12,
                    color: 'rgba(255,255,255,0.65)',
                    textDecoration: 'none',
                    transition: 'all 0.2s',
                  }}
                  onMouseEnter={(e) => {
                    e.currentTarget.style.borderColor = '#00AEEF';
                    e.currentTarget.style.color = '#00AEEF';
                  }}
                  onMouseLeave={(e) => {
                    e.currentTarget.style.borderColor = 'rgba(255,255,255,0.10)';
                    e.currentTarget.style.color = 'rgba(255,255,255,0.65)';
                  }}
                >
                  <span>💼</span> LinkedIn
                </a>
              </div>
            </div>
          </div>
        </div>

        {/* Bottom Bar */}
        <div
          style={{
            borderTop: '1px solid rgba(255,255,255,0.07)',
            paddingTop: 24,
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            flexWrap: 'wrap',
            gap: 10,
          }}
        >
          <p style={{ fontSize: 12, color: 'rgba(255,255,255,0.35)' }}>
            © {new Date().getFullYear()} E.A.T. All rights reserved.
          </p>
          <div style={{ display: 'flex', gap: 16, alignItems: 'center', flexWrap: 'wrap' }}>
            <p style={{ fontSize: 12, color: 'rgba(255,255,255,0.35)' }}>
              CampusToCorp - Internship & Corporate Readiness Program
            </p>
            <Link
              to="/privacy"
              style={{
                fontSize: 12,
                color: 'rgba(255,255,255,0.30)',
                textDecoration: 'none',
                transition: 'color 0.2s',
              }}
              onMouseEnter={(e) => (e.currentTarget.style.color = '#00AEEF')}
              onMouseLeave={(e) => (e.currentTarget.style.color = 'rgba(255,255,255,0.30)')}
            >
              Privacy Policy
            </Link>
          </div>
        </div>

        {/* Analytics disclosure — subtle gray line */}
        <p
          style={{
            fontSize: 11,
            color: 'rgba(255,255,255,0.22)',
            marginTop: 14,
            lineHeight: 1.6,
          }}
        >
          We collect anonymous usage data (device type, approximate location, pages viewed and time
          on page) to improve this site. See our{' '}
          <Link
            to="/privacy"
            style={{ color: 'rgba(255,255,255,0.32)', textDecoration: 'underline' }}
          >
            Privacy Policy
          </Link>
          .
        </p>
      </div>

      <style>{`
        @media (max-width: 900px) {
          .footer-grid { grid-template-columns: 1fr 1fr !important; }
        }
        @media (max-width: 560px) {
          .footer-grid { grid-template-columns: 1fr !important; }
        }
      `}</style>
    </footer>
  );
}
